import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setPreferencesPartial } from "../../../store/expertise/expertise.reducer";
import { fetchProfessionsAndSpecialites } from "../../../store/expertise/expertise.action";
import { Caption, Title } from "../../shared/Texts";
import QuotaMaxTle from "../QuotaMaxTle";
import ProfessionsSpecialitesAutorisees from "./ProfessionsSpecialitesAutorisees";

export default function Restrictions() {
	const dispatch = useAppDispatch();
	const limitToAutorizedProfessionsAndSpecialites = useAppSelector((state) => state.expertise.preferences?.preferencesRestriction?.limitToAutorizedProfessionsAndSpecialites);
	const professionsAndSpecialitesLoaded = useAppSelector((state) => state.expertise.professionsAndSpecialites !== undefined);
	// L'Autocomplete des professions/specialités reste ouvert après « Tout sélectionner », même si aucune restriction effective n'est alors enregistrée.
	const [isProfessionsSelectorOpen, setIsProfessionsSelectorOpen] = useState(limitToAutorizedProfessionsAndSpecialites ?? false);

	useEffect(() => {
		if (isProfessionsSelectorOpen && !professionsAndSpecialitesLoaded) {
			dispatch(fetchProfessionsAndSpecialites());
		}
	}, [dispatch, isProfessionsSelectorOpen, professionsAndSpecialitesLoaded]);

	const setLimitToAutorizedProfessionsAndSpecialites = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			setIsProfessionsSelectorOpen(event.target.checked);
			dispatch(
				setPreferencesPartial({
					preferencesRestriction: { limitToAutorizedProfessionsAndSpecialites: event.target.checked },
				})
			);
		},
		[dispatch]
	);

	return (
		<Grid container direction={"column"}>
			<Grid item>
				<Title text={"Restriction des sollicitations"} />
			</Grid>
			<Grid item marginTop={2}>
				<Caption text={"Par défaut, vous pouvez être contacté librement en Téléexpertise."} />
				<Caption text={"Activez les restrictions ci-dessous si vous souhaitez restreindre les demandes qui vous sont adressées."} />
			</Grid>
			<Grid item marginTop={1}>
				<QuotaMaxTle />
			</Grid>
			<Grid item marginTop={1}>
				<FormControlLabel
					control={<Checkbox id="limit-authorized-professions" checked={isProfessionsSelectorOpen} onChange={setLimitToAutorizedProfessionsAndSpecialites} />}
					label="Limiter les professions et spécialités autorisées à me contacter"
				/>
				{isProfessionsSelectorOpen && <ProfessionsSpecialitesAutorisees />}
			</Grid>
		</Grid>
	);
}
